import React from 'react';
import { OpenXLogo } from '../../assets';
import { Link, useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import { StoreHelpIcon, StoreUserAvatar } from '../../assets/svgs';
import FlatButtons from '../FlatButton/FlatButton';


export const StoreNavbar: React.FC = () => {
  const navigate = useNavigate()
    const Logo = () => (
    <div className={styles.logoContainer}>
      <OpenXLogo
        className={styles.logo}
        onClick={() => {
          // window.location.href = '/';
          navigate("/")
        }}
      />
    </div>
    );

  return (
    <nav className={styles.storeNavbar}>
      <div className={styles.storeNavbarContainer}>
        <div className={styles.brand}>
          <Link to="/create-store" className={styles.brandLink}>
            <div className={styles.logo}>
              <div className={styles.logoSection}>
              <Logo />
            </div>
            </div>
          </Link>
        </div>

        <div className={styles.rightSection}>
          <FlatButtons
          className={styles.helpButton}>
            <img
            src={StoreHelpIcon}
            alt='help icon'
            className={styles.helpButtonIcon} />
          </FlatButtons>
          <FlatButtons
          className={styles.userAvatar}>
            <img
            src={StoreUserAvatar}
            alt='user icon'
            className={styles.userAvatarIcon} />
          </FlatButtons>
        </div>
      </div>
    </nav>
  );
};